import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import Arrow from "../../assets/svg/arrow-right.inline.svg";


const Holder = styled.nav`
  display: flex;
  justify-content: space-between;
  color: black;
  padding-bottom: 6rem;

  .left {
    display: none;
  }
  .right {
    text-align: left;
  }

  p {
    display: inline-block;
  }


  h3 {
    font-family: "GT Flexa", sans-serif;
    font-weight: bold;
    color: #ff00ff;
    ${(props) => props.theme.fluidType(5)}
  }

  @media (${(props) => props.theme.breakpoints.md}) {
      .left {
        display: block;
        text-align: left;
      }
      .right {
        text-align: right;
      }
      h3 {
        ${(props) => props.theme.fluidType(0)}
      }
  }
`;

const LinkHolder = styled.div`

  @media (${(props) => props.theme.breakpoints.md}) {
    max-width: 40%;
    .right {
      display: flex;
      justify-content: flex-end;
  }
  }

  
`;

const ArrowHolder = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 2rem;
  }

  .rotate {
    rotate: 180deg;
  }

`

function Pagination({ next, prev }) {

  return (
      <Holder>
        <LinkHolder className="left">
          { prev && (
            <Link to={`/perspectives/${prev.uid}`} rel="prev">
              <ArrowHolder>
                <Arrow className="rotate"/>
                <p>PREVIOUS</p>
              </ArrowHolder>
              <h3>{prev.data.title.text}</h3>
            </Link>
          )}
        </LinkHolder>
        <LinkHolder className="right">
          { next && (
            <Link to={`/perspectives/${next.uid}`} rel="next">
              <ArrowHolder className="right">
                <p>NEXT</p>
                <Arrow />
              </ArrowHolder>
              <h3>{next.data.title.text}</h3>
            </Link>
          )}
        </LinkHolder>
      </Holder>
  );
}

Pagination.propTypes = {
  next: PropTypes.object,
  prev: PropTypes.object
};

export default Pagination;

